import React, { useState, useEffect, useRef } from 'react'
import './Profileinfo.css'
import Closeicon from "../../../Assests/X.svg"
import Dollar from "../../../Assests/Dollar Coins.svg"
import Edit from "../../../Assests/edit.svg"
import { useDispatch, useSelector } from 'react-redux'
import { setProfileShow } from '../../../redux/notificationSlice'
import Insta from "../../../Assests/Insta.svg"
import LinkedIn from "../../../Assests/Linkedin.svg"
import Facebook from "../../../Assests/Facebook.svg"
import Spotify from "../../../Assests/Spotify.svg"
import Youtube from "../../../Assests/Youtube.svg"
import Avatar from "../../../Assests/DefAvatar.png";
import Switch from "../../../Components/switch"
import { Tooltip } from "@mui/material";
import { useNavigate } from 'react-router-dom'
import { setValue, setPaymentUser, setIsPaymentOpen, setIsChatOpen, clearUserMessage, setUserMessage } from '../../../redux/valueSlice';
import { CometChat } from '@cometchat/chat-sdk-javascript';
import ConnectButton from '../../../Components/ConnectButton'
import Stripe from '../../../Assests/Stripe.svg';
import { ActionMenu } from '../Community/CommunityProfileCard';
import KebabIcon from '../../../Assests/kebab menu.svg';
import ActionConfirmDialog from '../../../Components/ActionConfirmDialog';
import UndoToast from '../../../Components/UndoToast';
import ReportProfileDialog from '../../../Components/ReportProfileDialog';
import ActionButtonIcon from '../../../Assests/Action Button.svg';
import messageIcon from "../../../Assests/cardMsg.svg";
import { useActionDialogs } from '../Community/useActionDialogs';
import { checkStripeAccount } from "../../../Services/stripeApi";
import { capitalizeNames } from '../../../utils/nameUtils';


// Add a style for blue filter
const stripeBlueFilter = 'invert(41%) sepia(98%) saturate(7496%) hue-rotate(202deg) brightness(97%) contrast(101%)';

const Profileinfo = ({ profileInfoRef }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const user = useSelector((state) => state?.user || []);
    const value = useSelector((state) => state?.value || []);
    const viewProfile = value?.viewSearchProfile || false;

    const userProfile = viewProfile ? value?.userData : (user || {});
    const { FirstName, LastName,
        Collaborate, connectionCount,
        connectionProfile,
        FacebookLink,
        InstagramLink,
        LinkedinLink,
        SpotifyLink,
        YoutubeLink,
        ProfileImageKey,
        Bio,
        Topics,
        UserID,
        Rate } = userProfile || {};

    const [isOpenToCollaborate, setIsOpenToCollaborate] = useState(Collaborate === 1);
    const [stripeHover, setStripeHover] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [hovered, setHovered] = useState('');
    const [hasStripeAccount, setHasStripeAccount] = useState(false);
    const shouldTransition = value?.shouldTransition !== false;
    const menuRef = useRef(null);
    const kebabBtnRef = useRef(null);
    const userName = capitalizeNames(FirstName, LastName).fullName;
    const {
        dialogConfig,
        setDialogConfig,
        isReportDialogOpen,
        setIsReportDialogOpen,
        toastConfig,
        setToastConfig,
        handleUnfollow: originalHandleUnfollow,
        handleBlock: originalHandleBlock,
        handleReport: originalHandleReport,
        onReport: originalOnReport,
        handleUndo,
    } = useActionDialogs(userName, UserID);

    const handleUnfollow = () => {
        handleProfileCloseInstant();
        originalHandleUnfollow();
    };

    const handleBlock = () => {
        handleProfileCloseInstant();
        originalHandleBlock();
    };

    const handleReport = () => {
        handleProfileCloseInstant();
        originalHandleReport();
    };

    const onReport = (reportData) => {
        handleProfileCloseInstant();
        originalOnReport(reportData);
    };

    const getTopicsArray = () => Topics ? JSON.parse(Topics) : [];
    const getConnections = () => connectionProfile || [];
    const getCollaborationStatus = () => isOpenToCollaborate ? "Open to Collaboration" : "Closed to Collaboration";
    const getCollaborationClass = () => isOpenToCollaborate ? 'profilecard_collab_open_status' : 'profilecard_collab_close_status';
    const hasSocialLinks = () => !!(YoutubeLink || LinkedinLink || InstagramLink || SpotifyLink || FacebookLink);
    const isConnected = () => userProfile?.ConnectionStatus === 'ACCEPTED';
    const shouldShowBottomActions = () => viewProfile && !value?.viewFromRequests && isConnected();

    const topicsArray = getTopicsArray();
    const connections = getConnections();

    useEffect(() => {
        setIsOpenToCollaborate(Collaborate === 1);
    }, [Collaborate]);

    useEffect(() => {
        if (viewProfile && UserID) {
            checkStripeAccount(UserID).then(response => {
                setHasStripeAccount(response?.status === 'active' || false);
            }).catch(() => setHasStripeAccount(false));
        }
    }, [viewProfile, UserID]);

    const handleProfileClose = () => {
        dispatch(setValue({ shouldTransition: true }));
        dispatch(setProfileShow(false));

        // The delay below prevents immediate profile switching.
        // Without it, the logged-in user's profile briefly appears for a split second.
        setTimeout(() => {
            dispatch(setValue({ viewSearchProfile: false, viewFromRequests: false }));
        }, 200);
    }

    const handleProfileCloseInstant = () => {
        dispatch(setValue({ shouldTransition: false }));
        dispatch(setProfileShow(false));
        dispatch(setValue({ viewSearchProfile: false, viewFromRequests: false }));
    }

    const toggleSwitch = () => {
        setIsOpenToCollaborate(!isOpenToCollaborate)
    };

    const handleProfileEdit = () => {
        dispatch(setProfileShow(false));
        navigate('/user-profile')
    }

    const handleStripeClick = async () => {
        if (value.isPaymentOpen) {
            dispatch(setIsPaymentOpen(false));
        } else {
            const hasStripeAccount = await checkStripeAccount(UserID);
            if (hasStripeAccount && isOpenToCollaborate) {
                dispatch(setPaymentUser(userProfile));
                dispatch(setIsPaymentOpen(true));
            }
        }
    }

    const handleMessageClick = async () => {
        dispatch(setIsChatOpen(true));
        dispatch(setProfileShow(false));
        
        const usersRequest = new CometChat.UsersRequestBuilder()
            .friendsOnly(true)
            .setLimit(50)
            .build();

        const connections = await usersRequest.fetchNext();
        let selectedUser = connections.find((user) => user.uid === UserID);
        dispatch(setUserMessage([selectedUser]));
    }

    const renderCollaborationStatus = () => (
        <div className='profilecard_collab_status'>
            <div className={getCollaborationClass()}></div>
            <span className={viewProfile ? '' : 'profile_text'}>
                {getCollaborationStatus()}
            </span>
        </div>
    );

    const renderSocialLink = (link, icon, platform) => {
        if (!link) return null;
        
        return (
            <Tooltip title={<span style={{ fontSize: '1vh' }}>View {platform} Profile</span>}>
                <div>
                    <a href={link} target="_blank" rel="noopener noreferrer">
                        <img className="socialsfacebook-icon" alt="" src={icon} />
                    </a>
                </div>
            </Tooltip>
        );
    };

    const renderConnectionButton = () => {
        if (!viewProfile) {
            return (
                <button className='profile_Edit' onClick={handleProfileEdit}>
                    <span style={{ color: '#fff', fontSize:'1.6vh' }}>Edit</span>
                    <img src={Edit} style ={{height:"2.8vh", width:"2.8vh"}}alt="Edit profile" />
                </button>
            );
        }

        if (isConnected()) {
            return <span className='profile-header-connected-badge'>Connected</span>;
        }

        return <ConnectButton ConnectionStatus={userProfile?.ConnectionStatus} ReceiverID={UserID} />;
    };

    const info = useSelector((state) => state.info)
    return (
        <>
            {info?.profileShow && (
                <button 
                    className="profile-backdrop"
                    onClick={handleProfileClose}
                    aria-label="Close profile"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        backdropFilter: 'blur(0.5px)',
                        zIndex: 9999,
                        border: 'none',
                    }}
                />
            )}
            <div 
                className="profile_container" 
                ref={profileInfoRef}
                style={{
                    position: 'fixed',
                    top: '50%',
                    right: info?.profileShow ? '30%' : '-100%',
                    transform: 'translateY(-50%)',
                    transition: shouldTransition ? 'right 0.5s ease-in-out' : 'none',
                    zIndex: 10000
                }}
            >
                <div className="profile_info">
                    <div className="profile_img">
                            <img alt="Profile" src={ProfileImageKey || Avatar} key={UserID} />
                    </div>
                    <div className='profile_data'>
                        <div className='profile_data_top'>
                            <div className='profile_user'>
                                <span className='profile_user_name'>{capitalizeNames(FirstName || "Guest", LastName || "").fullName}</span>
                                {/* <span className='profile_user_role'>Podcast Creator</span> */}
                            </div>
                            <button className='profile_close' onClick={handleProfileClose} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
                                <img src={Closeicon} alt="Close" />
                            </button>
                        </div>
                        <div className='profile_data_bottom'>
                            <div className='profile_data_connection'>
                                <span className='profile_connection_count'>{connectionCount || 0}</span>
                                <span className='profile_text connection'>Connections</span>
                            </div>
                            <div className='profile_user_connections'>
                                {connections.slice(0, 3).map((item, index) => (
                                    <img
                                        key={index}
                                        className={`connectedUser${index + 1}`}
                                        src={item?.ProfileImageKey}
                                            alt="Connection"
                                    />
                                ))}
                            </div>
                        </div>
                        <div className='profile_data_second_bottom'>
                            <div className='profile_data_collabaration'>
                                {renderCollaborationStatus()}
                            </div>
                            <div className='profile_data_pricing'>
                                    <img src={Dollar} alt="Rate" />
                                <span>$ {Rate}/Ep</span>
                                {viewProfile && (() => {
                                    const getTooltipTitle = () => {
                                        if (!hasStripeAccount && !isOpenToCollaborate) {
                                            return "This user hasn't set up payments and is not open to collaboration";
                                        }
                                        if (!hasStripeAccount) {
                                            return "This user hasn't set up payments yet";
                                        }
                                        if (!isOpenToCollaborate) {
                                            return "This user is not open to collaboration";
                                        }
                                        return "Collab Checkout";
                                    };
                                    
                                    return (
                                        <Tooltip title={getTooltipTitle()} placement="right-start" PopperProps={{ style: { zIndex: 10001 } }}>
                                        <button
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                width: '3.6vh',
                                                height: '3.6vh',
                                                padding: 0,
                                                cursor: hasStripeAccount && isOpenToCollaborate ? 'pointer' : 'not-allowed',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                transition: 'filter 0.2s',
                                                opacity: hasStripeAccount && isOpenToCollaborate ? 1 : 0.5
                                            }}
                                            onMouseEnter={() => hasStripeAccount && isOpenToCollaborate && setStripeHover(true)}
                                            onMouseLeave={() => setStripeHover(false)}
                                            onMouseDown={() => hasStripeAccount && isOpenToCollaborate && setStripeHover(true)}
                                            onMouseUp={() => setStripeHover(false)}
                                            onClick={hasStripeAccount && isOpenToCollaborate ? handleStripeClick : undefined}
                                            disabled={!hasStripeAccount || !isOpenToCollaborate}
                                        >
                                            <img src={Stripe} alt="Stripe" style={{ width: '3.6vh', height: '3.6vh', filter: stripeHover && hasStripeAccount && isOpenToCollaborate ? stripeBlueFilter : 'none', transition: 'filter 0.2s' }} />
                                        </button>
                                    </Tooltip>
                                    );
                                })()}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="profile_content">
                    <div className="profile_content_title">Bio</div>
                    <div className="profile_text">{Bio || "This user hasn’t updated their bio yet !"}</div>
                </div>
                <div className="profile_content">
                    <div className="profile_content_title">Interests</div>
                    <div className="profile_content_interest">
                        {topicsArray.length > 0 ? (
                            topicsArray.map((item, index) => (
                                <div key={index} className="profile_content_interest_item">
                                    <span>#</span>
                                    <span>{item}</span>
                                </div>
                            ))
                        ) : (
                            <span>This user hasn’t picked any topics of interest yet !</span>
                        )}
                    </div>
                </div>
                <div className="profile_content">
                    <div className="profile_content_title">Connect On</div>
                    <div className="profile_content_socials">
                        <div className='profile_content_social_wrapper'>
                            {renderSocialLink(FacebookLink, Facebook, "Facebook")}
                            {renderSocialLink(SpotifyLink, Spotify, "Spotify")}
                            {renderSocialLink(InstagramLink, Insta, "Instagram")}
                            {renderSocialLink(LinkedinLink, LinkedIn, "LinkedIn")}
                            {renderSocialLink(YoutubeLink, Youtube, "YouTube")}
                            {!hasSocialLinks() && <span>This user hasn't linked any social media profiles yet.</span>}
                        </div>
                        {renderConnectionButton()}
                    </div>
                </div>
                    {/* Add the bottom action buttons here */}
                    {shouldShowBottomActions() && (
                      <div className="profile-bottom-actions">
                        <div className="profile-bottom-left-center">
                            <div className="profile-bottom-left">
                            <button className="profile-connected-btn">Connected</button>
                            </div>
                            <div className="profile-bottom-center">
                            <button
                                className="profile-message-btn"
                                onClick={handleMessageClick}
                            >
                                <span>Message</span>
                                <img src={messageIcon} alt="Message" style={{ marginLeft: 8 }} />
                            </button>
                            </div>
                        </div>
                        <div className="profile-bottom-right">
                          <button className="profile-kebab-btn" ref={kebabBtnRef} onClick={() => setIsMenuOpen((prev) => !prev)}>
                            <img src={isMenuOpen ? KebabIcon : ActionButtonIcon} alt="More" />
                          </button>
                          <ActionMenu
                            isOpen={isMenuOpen}
                            anchorRef={kebabBtnRef}
                            onClose={() => setIsMenuOpen(false)}
                            onUnfollow={handleUnfollow}
                            onBlock={handleBlock}
                            onReport={handleReport}
                            hovered={hovered}
                            setHovered={setHovered}
                            menuRef={menuRef}
                            customStyle={{ left: "78%", bottom: '56px', top: '45%' }}
                          />
                        </div>
                      </div>
                    )}
                    {/* Render dialogs and toast at the bottom */}
                    {dialogConfig && (
                        <ActionConfirmDialog
                            open={Boolean(dialogConfig)}
                            onClose={() => setDialogConfig(null)}
                            title={dialogConfig.title}
                            message1={dialogConfig.message1}
                            message2={dialogConfig.message2}
                            actionText={dialogConfig.actionText}
                            onAction={dialogConfig.onAction}
                            actionIcon={dialogConfig.actionIcon}
                        />
                    )}
                    <ReportProfileDialog
                        open={isReportDialogOpen}
                        onClose={() => setIsReportDialogOpen(false)}
                        userName={capitalizeNames(FirstName, LastName).fullName}
                        onReport={onReport}
                    />
            </div>
            <UndoToast
                message={toastConfig.message}
                visible={toastConfig.visible}
                showUndo={toastConfig.showUndo}
                onUndo={handleUndo}
            />
        </>
    )
}

export default Profileinfo
